<!-- 由 suu 创建于 2022-05-05 星期四 -->
<template>
  <div class="ques-radio-gender">
    <div class="q-title">{{ info.field_title }}</div>
    <div class="gender-list">
      <div
        class="gender-item"
        :class="{
          'gender-item-active': info.field_unit[index].key == value,
          'gender-item-active-nv':
            info.field_unit[index].key == value && value == '女'
        }"
        v-for="(item, index) in info.field_unit"
        @click="handelChange(item)"
        :key="index"
      >
        <img
          class="i-img"
          :src="
            info.field_unit[index].key == value
              ? gender[item.key].imgAc
              : gender[item.key].img
          "
        />
        <div class="i-desc">
          <div class="d-top">{{ gender[item.key].top }}</div>
          <div class="d-bot">{{ gender[item.key].bot }}</div>
        </div>
        <div
          class="iconfont icon-gou"
          v-if="info.field_unit[index].key == value"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ques-radio-gender',

  components: {},

  props: {
    info: {}
  },

  data() {
    return {
      gender: {
        男: {
          img: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/yypgfa-ques-xb-nan',
          imgAc:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/yypgfa-ques-xb-nan-xz',
          top: 'BOY',
          bot: '男生'
        },
        女: {
          img: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/yypgfa-ques-xb-nv',
          imgAc:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/yypgfa-ques-xb-nv-xz',
          top: 'GIRL',
          bot: '女生'
        }
      },
      value: '' //当心选择选项的的key
    }
  },

  computed: {},

  watch: {},

  created() {
    this.value = this.info.value
  },

  mounted() {},

  destroyed() {},

  methods: {
    // 性别选择
    handelChange(item) {
      this.value = item.key
      this.$emit('on-change', this.value)
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 750) * 100vw;
}
.ques-radio-gender {
  text-align: center;

  .q-title {
    text-align: left;
    font-size: vw(48);
    font-weight: 600;
    margin-left: vw(36);
    color: #000;
    margin-bottom: vw(96);
  }
  .gender-list {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: vw(64);
  }
  .gender-item {
    width: 100%;
    box-sizing: border-box;
    height: vw(168);
    background: #f5f6fa;
    border-radius: vw(24);
    display: flex;
    align-items: center;
    padding: 0 vw(52);
    font-weight: bold;
    color: #39365d;
    margin-bottom: vw(20);
    padding-top: vw(16);
    overflow: hidden;
  }
  .i-img {
    width: vw(152);
    /* height: auto; */
  }
  .i-desc {
    margin-left: vw(50);
    text-align: left;
  }
  .d-top {
    font-size: vw(60);
  }
  .d-bot {
    font-size: vw(32);
    margin-top: -vw(4);
  }
  .icon-gou {
    font-size: vw(40);
    font-weight: bold;
    margin-left: vw(100);
  }
  .gender-item-active {
    // background-color: #6080FF;
    background-color: #977af4;
    color: #fff;
  }
  .gender-item-active-nv {
    background-color: #f77b94;
  }
  .desc {
    width: vw(484);
    margin: 0 auto;
    font-size: vw(24);
    line-height: vw(36);
    text-align: center;
    color: rgba(0, 0, 0, 0.5);
  }
  .desc .text {
    display: inline-block;
    text-align: left;
  }
}
</style>
